import React from 'react';
import Link from 'next/link';

import { Button, Card, CardContent, Label, RequestHistory } from '@shared/ui';
import { Nodatadounat } from '@/icons/iconsComponent';

import { goldAssetsLanguages } from '../model';

export const GoldEmptyAsset = () => {
  return (
    <div className='flex flex-col gap-2'>
      <Card className='flex flex-col items-center justify-center w-full !mt-[14px] py-4'>
        <Nodatadounat />
        <Label className='text-disableText body-12-bold leading-[20.73px] pb-4 pt-3'>
          سبد دارایی‌های شما خالی است.
        </Label>
        <Link href={'/investment/gold'}>
          <Button id='btn_gold_plan'>سرمایه‌گذاری در طرح طلا</Button>
        </Link>
      </Card>
      <Card className='w-full bg-background mt-3 !h-fit'>
        <CardContent className='w-full p-3 flex flex-row justify-around items-center'>
          <Link
            href='/assets/gold/history'
            className='flex flex-col items-center justify-center gap-2'
          >
            <RequestHistory />
            <Label className='text-text !body-13-regular leading-[24.18px] text-center'>
              {goldAssetsLanguages.requestHistory}{' '}
            </Label>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};
